<script setup lang="ts">
  import { computed } from 'vue';
  import type { ChatBgShapeConfig } from '@/models/chat';

  const props = defineProps({
    color1: {
      type: String,
      required: true
    },
    color2: {
      type: String,
      required: true
    },
    isChameleonMode: {
      type: Boolean,
      default: false
    }
  });

  const chameleonMode = computed(() => props.isChameleonMode);

  const shapeConfig: ChatBgShapeConfig = {
    initialStart: {
      top: 6.81,
      left: 1145.67,
      width: 577.425,
      height: 925.366,
      rotation: -70.145,
      duration: 2,
      repeat: 0,
      yoyo: false,
      ease: 'power1.inOut'
    },
    initialEnd: {
      top: -473.61,
      left: 1187.28,
      width: 711.621,
      height: 1154.236,
      rotation: -81.803,
      duration: 15,
      repeat: -1,
      yoyo: true,
      ease: 'power1.inOut'
    },
    chameleonStart: {
      top: 44.25,
      left: 1127.2,
      width: 776.452,
      height: 1184.728,
      rotation: -56.111,
      duration: 2,
      repeat: 0,
      yoyo: false,
      ease: 'power1.inOut'
    },
    chameleonEnd: {
      top: -189.78,
      left: 951.55,
      width: 584.559,
      height: 913.802,
      rotation: 28.581,
      duration: 15,
      repeat: -1,
      yoyo: true,
      ease: 'power1.inOut'
    }
  };

  const { svgRef } = useChatBgShape(chameleonMode, shapeConfig);
</script>

<template>
  <svg
    ref="svgRef"
    :class="['chat-bg-shape', 'chat-bg-shape--6', { chameleon: chameleonMode }]"
    :style="{ '--chat-bg-color-1': color1, '--chat-bg-color-2': color2 }"
    width="561"
    height="925"
    viewBox="0 0 561 925"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M462.292 50.4639C334.369 -116.502 82.4157 165.077 256.365 396.625C364.917 541.121 -25.3344 600.943 2.23955 769.799C29.583 937.243 173.636 944.7 259.005 903.559C486.553 793.897 686.166 342.664 462.292 50.4639Z"
      fill="url(#paint0_radial_7_10)" />
    <defs>
      <radialGradient
        id="paint0_radial_7_10"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(15.8564 1027.56 -3623.32 -663.081 468.112 48.5155)"
        gradientUnits="userSpaceOnUse">
        <stop
          class="color1"
          offset="0" />
        <stop
          class="color2"
          offset="1" />
      </radialGradient>
    </defs>
  </svg>
</template>
